module.exports = __webpack_public_path__ + "static/media/pc_qr_code.1f12bbb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/agenda/image/pc_qr_code.png
// module id = 1197
// module chunks = 0